import { useMemo } from 'react';
import { type CreatePageInfo, type ImageToolValues, VIDEO_TOOL, type VideoToolValues } from '@/app/types';
import { usePathname } from '@/i18n/routing';

function isVideoToolValue(value: string): value is VideoToolValues {
  return (Object.values(VIDEO_TOOL) as string[]).includes(value);
}

export const usePageType = () => {
  const pathname = usePathname();

  const pageInfo = useMemo(() => {
    const isCreatePage = pathname.match(/\/create\/\w+/);
    if (isCreatePage) {
      // 解析 create 页面的工具信息
      let createPageInfo: CreatePageInfo | undefined;
      const toolMatch = pathname.match(/\/create\/(\w+)/);
      if (toolMatch) {
        const toolName = toolMatch[1] as VideoToolValues | ImageToolValues;

        // 根据工具名称判断工具类别
        if (isVideoToolValue(toolName)) {
          createPageInfo = {
            toolType: 'video',
            tool: toolName,
          };
        } else {
          createPageInfo = {
            toolType: 'image',
            tool: toolName,
          };
        }
      }
      return {
        isCreatePage,
        createPageInfo,
      };
    }

    return {
      isTemplatesPage: pathname.match(/\/templates\/\w+/),
      isText2AudioPage: pathname.match(/\/(text2audio|tools\/ai-sound-effects)/),
      isMyCreationsPage: pathname.startsWith('/assets/mycreations') || pathname.startsWith('/mycreations'),
    };
  }, [pathname]);

  return pageInfo;
};
